export default __webpack_public_path__ + "resources/icons/n300-8855.png";